import { createSlice } from "@reduxjs/toolkit";
const initialVal = { value: null };
export const customerSlice = createSlice({
    name: "customer",
    initialState: initialVal,
    reducers: {
        setCustomer: (state, action) => {
            state.value = action.payload;
        },
    },
});
export const { setCustomer } = customerSlice.actions;
export default customerSlice.reducer;
